import { Spinner } from 'components/Elements';
import React, { useEffect, useState } from 'react';
import { imageToBlob } from 'utils/ImageToBlob';

export const ProofOfTransaction = ({ imgSrc }) => {
  const [summaryImg, setSummaryImg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const imgToBlob = async () => {
      setIsLoading(true);
      const summaryImg = await imageToBlob(imgSrc);

      console.log('Blob URL:', summaryImg);
      setSummaryImg(summaryImg);
      setIsLoading(false);
    };
    imgToBlob();
  }, [imgSrc]);

  return (
    <div>
      {isLoading ? (
        <div className="flex items-center justify-center h-32">
          <Spinner />
        </div>
      ) : (
        <div className="h-32 ">
          <img
            src={summaryImg}
            alt="Proof Of Transaction"
            className="rounded-3xl shadow-md"
          />
        </div>
      )}
    </div>
  );
};
